import React, { useState, useEffect } from 'react';
import { IoAdd, IoPencil, IoTrash, IoSave, IoClose } from 'react-icons/io5';
import { toast } from 'react-toastify';
import adminService from '../../../services/adminService'; // Import Service đã tạo
import styles from './FAQManager.module.scss'; 

const FAQManager = () => {
  const [faqs, setFaqs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  
  // State form
  const [formData, setFormData] = useState({
    id: null,
    question: '',
    answer: '',
    sort_order: 0,
    is_active: 1
  });

  // Load danh sách khi vào trang
  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const res = await adminService.getFaqs();
      setFaqs(res.data);
    } catch (error) {
      console.error(error);
      // Nếu lỗi 401 (hết phiên) thì adminService (axios interceptor) thường sẽ tự xử lý hoặc ta báo lỗi chung
      toast.error("Lỗi tải dữ liệu FAQ.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        // Cập nhật
        await adminService.updateFaq(formData);
        toast.success("Cập nhật thành công!");
      } else {
        // Thêm mới
        await adminService.createFaq(formData);
        toast.success("Thêm mới thành công!");
      }
      fetchFaqs(); // Tải lại danh sách
      resetForm(); // Xóa form
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lưu.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bạn chắc chắn muốn xóa câu hỏi này?")) {
      try {
        await adminService.deleteFaq(id);
        toast.success("Đã xóa!");
        fetchFaqs();
      } catch (error) {
        console.error(error);
        toast.error("Lỗi xóa FAQ.");
      }
    }
  };

  const handleEdit = (faq) => {
    setFormData(faq);
    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Cuộn lên đầu trang để sửa
  };

  const resetForm = () => {
    setFormData({ id: null, question: '', answer: '', sort_order: 0, is_active: 1 });
    setIsEditing(false);
  };

  return (
    <div className={styles.container}>
      <h2>Quản Lý FAQ (Câu hỏi thường gặp)</h2>

      {/* --- FORM THÊM/SỬA --- */}
      <div className={styles.formWrapper}>
        <h4>{isEditing ? 'Chỉnh Sửa FAQ' : 'Thêm Câu Hỏi Mới'}</h4>
        <form onSubmit={handleSubmit} className={styles.form}>
          
          <input 
            type="text" 
            placeholder="Câu hỏi (VD: Giao hàng trong bao lâu?)" 
            value={formData.question} 
            onChange={e => setFormData({...formData, question: e.target.value})}
            required
            className={styles.inputField}
          />
          
          <textarea 
            rows="4"
            placeholder="Câu trả lời (Chấp nhận xuống dòng)"
            value={formData.answer}
            onChange={e => setFormData({...formData, answer: e.target.value})}
            required
            className={styles.inputField}
          ></textarea>

          <div className={styles.formRow}>
            <label>
              Thứ tự: 
              <input 
                type="number" 
                value={formData.sort_order} 
                onChange={e => setFormData({...formData, sort_order: e.target.value})}
                className={styles.smallInput}
              />
            </label>
            <label>
              <input 
                type="checkbox" 
                checked={formData.is_active == 1} 
                onChange={e => setFormData({...formData, is_active: e.target.checked ? 1 : 0})}
              /> Hiển thị ngay
            </label>
          </div>

          <div className={styles.buttonGroup}>
            <button type="submit" className={`${styles.btn} ${styles.submitBtn}`}>
              {isEditing ? <><IoSave /> Lưu Thay Đổi</> : <><IoAdd /> Thêm Mới</>}
            </button>
            {isEditing && (
              <button type="button" onClick={resetForm} className={`${styles.btn} ${styles.cancelBtn}`}>
                <IoClose /> Hủy
              </button>
            )}
          </div>
        </form>
      </div>

      {/* --- DANH SÁCH --- */}
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th width="5%">TT</th>
              <th width="65%">Nội dung</th>
              <th width="15%">Trạng thái</th>
              <th width="15%">Hành động</th>
            </tr>
          </thead>
          <tbody>
            {faqs.map(faq => (
              <tr key={faq.id}>
                <td>{faq.sort_order}</td>
                <td>
                  <span className={styles.questionText}>{faq.question}</span>
                  <p className={styles.answerText}>{faq.answer}</p>
                </td>
                <td>
                  {faq.is_active == 1 
                    ? <span className={styles.statusActive}>Hiện</span> 
                    : <span className={styles.statusInactive}>Ẩn</span>}
                </td>
                <td>
                  <button onClick={() => handleEdit(faq)} className={`${styles.actionBtn} ${styles.editBtn}`} title="Sửa">
                    <IoPencil />
                  </button>
                  <button onClick={() => handleDelete(faq.id)} className={`${styles.actionBtn} ${styles.deleteBtn}`} title="Xóa">
                    <IoTrash />
                  </button>
                </td>
              </tr>
            ))}
            {faqs.length === 0 && (
              <tr>
                <td colSpan="4" style={{textAlign: 'center', padding: '30px', color: '#999'}}>
                  Chưa có câu hỏi nào. Hãy thêm mới!
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FAQManager;